import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eef2ff 0%, #e0f2fe 100%);
  padding: 2rem 1rem;
`;

const Card = styled.div`
  width: 100%;
  max-width: 420px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.15);
  padding: 2rem;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 1.4rem;
  font-weight: 800;
  color: #111827;
  margin-bottom: 0.75rem;
`;

const Text = styled.p`
  font-size: 0.95rem;
  color: #4b5563;
`;

const Activate = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (!token) {
      return;
    }
    const apiBase = process.env.REACT_APP_API_URL || '';
    // Backend aktivasyon endpoint'ine yönlendir; backend sonra /login?activated=1'e redirect edecek.
    window.location.href = `${apiBase}/api/auth/activate?token=${encodeURIComponent(
      token
    )}`;
  }, [location.search]);

  return (
    <PageContainer>
      <Card>
        <Title>Hesabınız aktifleştiriliyor</Title>
        <Text>Lütfen bekleyin, aktivasyon işlemi tamamlanırken yönlendirileceksiniz.</Text>
      </Card>
    </PageContainer>
  );
};

export default Activate;

